import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import FormInput from "../form/inputs/FormInput";
import { inputTypes } from "../../../constants/input-types";

export default function EmployeeCell({
  item,
  editingLocked,
  shouldLockCell,
  onInlineEdit,
  ignoreInlineKeys,
  itemKey,
  isValid,
  cellContent,
  shouldEmphasizeCell,
  handleInlineEdit,
  employeeSelectItems = [],
}) {
  return (
    <td
      className={
        item.isPending === true
          ? "pending-item"
          : item.isActive === false
            ? "inactive-item"
            : item.status === "Cancelled"
              ? "canceled-item"
              : undefined
      }
    >
      {!shouldLockCell &&
      !editingLocked &&
      onInlineEdit &&
      ignoreInlineKeys &&
      !ignoreInlineKeys.includes(itemKey) ? (
        <FormInput
          editable
          className={"ak-inline-input ak-custom-input"}
          errorMessage="Required"
          inputWidth={12}
          type={inputTypes.SELECTSTYLE2}
          selectItems={employeeSelectItems}
          placeholder="Select Employee..."
          onChange={(event) => handleInlineEdit(event, item, itemKey)}
          value={item[itemKey]}
          customStyles={{
            menu: (baseStyles, state) => {
              return {...baseStyles, zIndex: 99};
            },
          }}
        />
      ) : (
        <div
          style={{
            fontWeight: shouldEmphasizeCell ? "bolder" : "inherit",
          }}
        >
          {cellContent?.label}
        </div>
      )}
    </td>
  );
}
